import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function usePromotions(env, client) {
  const [loadedPromotions, setLoadedPromotions] = useState(false);
  const [promotions, setPromotions] = useState(null);

  useEffect(() => {
    setLoadedPromotions(false);
    if (!client) {
      setLoadedPromotions(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "promotions");
    
    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPromotions(data);
      setLoadedPromotions(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedPromotions, promotions };
}